import { configStore } from "@/store/store";

export function isBreakdanceDevelopmentEnvironment() {
  const url = new URL(document.location.href);

  if (url.searchParams.has("forceproduction")) return false;

  return configStore.environment === "local";
}
